<div class="container-lg text-center container-menu" style="background-color: #1d2229">
  <div class="row">
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" disabled>
        Cabinas
      </button>
    </div>
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" (click)="navigate('Chassis')">
        Chassis
      </button>
    </div>
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" (click)="navigate('KD')">KD</button>
    </div>
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" (click)="navigate('LCBExpedicao')">
        LCB Expedição
      </button>
    </div>
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" (click)="navigate('LCBRecebimento')">
        LCB Recebimento
      </button>
    </div>
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" (click)="navigate('LCBEmbalagens')">
        LCB Embalagens
      </button>
    </div>
    <div class="d-grid gap-2 col-sm-12 mx-auto">
      <button type="button" class="btn btn-outline-primary" (click)="navigate('MotoresTransmissao')">
        Motores & Transmissão
      </button>
    </div>
  </div>
</div>